import { render, staticRenderFns } from "./ArticleCardMobile.vue?vue&type=template&id=97f090ae&scoped=true&"
import script from "./ArticleCardMobile.vue?vue&type=script&lang=js&"
export * from "./ArticleCardMobile.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCardMobile.vue?vue&type=style&index=0&id=97f090ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f090ae",
  null
  
)

export default component.exports